module.exports = "/packs/images/svg/facilities/camping~566a2c71d996f365af3a2916de89a340.svg";